// Component Libraries
import NavBar from "../NavBar/NavBar";
import SideBar from "../SideBar/SideBar";
import ProjectDashboardContent from "../ProjectDashboardContent/ProjectDashboardContent";

import "./ProjectDashboard.scss";

const ProjectDashboard = () => {
  return (
    <div className="dashboard-outer-container">
      <NavBar />
      <div className="dashboard-outer-content-container">
        <div className="sidebar-container">
          <SideBar />
        </div>
        <ProjectDashboardContent />
      </div>
    </div>
  );
};

export default ProjectDashboard;
